module.exports = __webpack_public_path__ + "assets/7cde0983dd655d10f9a7efb86517a550.png";